import React, { useEffect, useState } from "react";
import { HiOutlineTrash } from "react-icons/hi";

// Props:
// - item: original cart item object
// - image: image url
// - title: product title
// - unitPrice: number
// - quantity: initial quantity
// - onQuantityChange(newQty)
// - onRemove()

export default function CartProductCard({
  item,
  image,
  title,
  unitPrice,
  brand_name,
  quantity = 1,
  onQuantityChange,
  onRemove,
}) {
  const [qty, setQty] = useState(Number(quantity) || 1);
  const brandName = item?.product?.brand_name || "Unknown Brand";
  const productImage = item?.product?.product_media?.[0]?.url || image;

  useEffect(() => {
    setQty(Number(quantity) || 1);
  }, [quantity]);

  function changeQty(newQty) {
    if (newQty < 1) return;
    setQty(newQty);
    if (typeof onQuantityChange === "function") onQuantityChange(newQty);
  }

  const totalPrice = (Number(unitPrice) || 0) * qty;

  return (
    <div
      className="w-full  min-h-[124px] bg-white border-b border-[#E5E5E5] p-4 flex flex-col sm:flex-row gap-4 items-start"
      style={{
        fontFamily:
          'Poppins, Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
      }}
    >
      {/* Image */}
      <div className="flex-shrink-0 w-full sm:w-[136px] h-[136px] bg-gray-50 rounded-md flex items-center justify-center overflow-hidden relative">
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <span className="absolute top-0 left-0 rounded-br-2xl rounded-tl-2xl bg-red-600 text-white text-xs font-semibold px-2 py-1">
          12 % Offer
        </span>
      </div>

      {/* Title/Variant/Selectors */}
      <div className="flex-1 min-w-0 w-full space-y-2">
        <div className="flex justify-between items-center">
          <div>
            <div className="text-sm font-medium text-gray-900 truncate">
              {title}
            </div>
            {/* {variant_name && (
              <div className="text-xs text-gray-500 mt-1 truncate">
                {variant_name}
              </div>
            )} */}
          </div>
          {/* Delete Button */}
          <button
            onClick={() => onRemove && onRemove(item?.id)}
            className="text-[#E63946] ml-2 p-1"
          >
            <HiOutlineTrash size={18} />
          </button>
        </div>
        {/* Size & Color Dropdowns */}
        <div className="flex gap-2">
          <select className="border rounded-full px-2 py-1 text-xs min-w-[64px]">
            <option value="">Size</option>
            {/* {availableSizes.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))} */}
          </select>
          <select className="border rounded-full px-2 py-1 text-xs min-w-[64px]">
            <option value="">Color</option>
            {/* {availableColors.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))} */}
          </select>
        </div>
        {/* Seller Name */}
        {/* <div className="text-xs text-black font-bold">
          <p className="w-[160px] p-2 rounded-xl border-[3px] mt-3 border-green-500 text-center"></p>
        </div> */}
        <div className="inline-flex border-2 gap-2 p-1 rounded-xl text-[12px] items-center">
          <div className="bg-white  ">
            <img
              src="/image/wanchain.png"
              alt="logo"
              className="w-[20px] h-[20px] object-contain"
            />
          </div>
          <div className="text-black">
            <p className="text-xs text-black font-semibold ">
             {brandName}
            </p>{" "}
          </div>
        </div>

        {/* Price & Quantity */}
        <div className="flex justify-end  items-center gap-2 min-w-[100px]">
          {/* Prices */}
          <div className="flex gap-2 items-center">
            <span className="text-gray-400 line-through text-xs">
              ${unitPrice.toFixed(2)}
            </span>
            <span className="text-sm font-bold text-[#095228]">
              ${totalPrice.toFixed(2)}
            </span>
          </div>
          {/* Quantity Selector */}
          <div className="flex items-center rounded-xl text-black border bg-[#F0F0F0]  overflow-hidden h-8">
            <button
              onClick={() => changeQty(qty - 1)}
              aria-label="decrease"
              className="px-3 py-1 text-sm   hover:opacity-90"
            >
              -
            </button>
            <div className="px-3 py-1 text-sm">{qty}</div>
            <button
              aria-label="increase"
              onClick={() => changeQty(qty + 1)}
              className="px-3 py-1 text-sm   hover:opacity-90"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
